import React from 'react';
import { Outlet } from 'react-router-dom';
import {
    DossierActionProvider,
    DossierArticleProvider,
    DossierGroupModal,
    DossierRoutingProvider,
    dossiersBasePath,
    DossierStepProvider,
    DossierUrgentModal,
    DossierValidatorProvider,
    ExportDossierModal,
    OfferProvider,
    SuspendDossierModal,
    UnsuspendDossierModal,
} from '@europrocurement/l2d-modules';
import { dossierValidationPath, addFormalityPath } from '../constants';
import { ordersBasePath } from '../../Orders';
import AssignDossierModal from './liste/ActionMenu/AssignDossierModal.tsx/AssignDossierModal';

export const DossierRoot: React.FunctionComponent = function () {
    return (
        <OfferProvider>
            <DossierStepProvider>
                <DossierActionProvider>
                    <DossierRoutingProvider
                        orderBasePath={ordersBasePath}
                        dossierBasePath={dossiersBasePath}
                        dossierValidationPath={dossierValidationPath}
                        addFormalityPath={addFormalityPath}
                    >
                        <DossierValidatorProvider>
                            <DossierArticleProvider>
                                <Outlet />
                            </DossierArticleProvider>
                        </DossierValidatorProvider>
                    </DossierRoutingProvider>
                    <DossierGroupModal />
                    <ExportDossierModal />
                    <DossierUrgentModal />
                    <SuspendDossierModal />
                    <UnsuspendDossierModal />
                    <AssignDossierModal />
                </DossierActionProvider>
            </DossierStepProvider>
        </OfferProvider>
    );
};
